// Google Analytics utility functions
export const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

// Check if analytics consent is given
const hasAnalyticsConsent = () => {
  const consent = localStorage.getItem('cookie-consent');
  if (!consent) return false;
  
  try {
    const preferences = JSON.parse(consent);
    return preferences.analytics === true;
  } catch {
    return false;
  }
};

// Initialize Google Analytics (already done in HTML, but this ensures it's available)
export const initGA = () => {
  if (!GA_MEASUREMENT_ID) {
    // Suppress warning in production - GA is optional
    if (process.env.NODE_ENV === 'development') {
      console.warn('Google Analytics Measurement ID not found');
    }
    return;
  }
  
  // gtag is loaded via the script in index.html
  if (typeof window.gtag !== 'undefined') {
    // Set default consent state
    window.gtag('consent', 'default', {
      'analytics_storage': 'denied',
      'ad_storage': 'denied'
    });
    
    window.gtag('config', GA_MEASUREMENT_ID);
  }
};

// Track page views
export const trackPageView = (pagePath, pageTitle) => {
  if (!GA_MEASUREMENT_ID || typeof window.gtag === 'undefined' || !hasAnalyticsConsent()) {
    return;
  }
  
  window.gtag('config', GA_MEASUREMENT_ID, {
    page_path: pagePath,
    page_title: pageTitle,
  });
};

// Track custom events
export const trackEvent = (eventName, parameters = {}) => {
  if (!GA_MEASUREMENT_ID || typeof window.gtag === 'undefined' || !hasAnalyticsConsent()) {
    return;
  }
  
  window.gtag('event', eventName, parameters);
};

// Track user interactions
export const trackUserAction = (action, category = 'User Interaction') => {
  trackEvent(action, {
    event_category: category,
    event_label: action
  });
};

// Track runbook interactions
export const trackRunbookAction = (action, runbookId, runbookTitle) => {
  trackEvent('runbook_interaction', {
    event_category: 'Runbook',
    event_label: action,
    runbook_id: runbookId,
    runbook_title: runbookTitle
  });
};